import React from "react";
import { Location } from "../Location";
import { ConsultantProfilePipeline } from "@consultants/consultant-profile-new/consultant-profile-pipeline";

interface Params {
  consultantId: string;
}

export class ConsultantProfileLocation extends Location<Params> {
  constructor(consultantId: string) {
    super({ consultantId });
  }

  render() {
    return <ConsultantProfilePipeline consultantId={this.params.consultantId} />;
  }

  toURI() {
    const { consultantId } = this.params;
    return `/consultants/${consultantId}`;
  }
}
